// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__3SPPw","card":"Cards_card__30bKO","infected":"Cards_infected__1cerK","recovered":"Cards_recovered__oNYKn","deaths":"Cards_deaths__6RAc8"};